var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7402 21.2413C19.1821 20.7114 19.9715 20.64 20.5017 21.0814L22.3853 22.6524C22.915 23.0944 22.9867 23.8825 22.5451 24.4128C22.1033 24.9426 21.3151 25.0141 20.7849 24.5726L18.9001 23.0028C18.3704 22.5608 18.2985 21.7715 18.7402 21.2413ZM12.8991 6.89684C13.2634 6.55874 13.7937 6.46772 14.2492 6.66613C14.7049 6.86483 14.9999 7.31526 15 7.81237V22.1874C15 22.6845 14.705 23.1349 14.2492 23.3336C13.7936 23.532 13.2634 23.441 12.8991 23.1029L8.88427 19.3749H6.25C4.86929 19.3749 3.75 18.2555 3.75 16.8749V13.1249C3.7501 11.7442 4.86935 10.6249 6.25 10.6249H8.88427L12.8991 6.89684ZM23.75 13.7499C24.4401 13.7501 24.9999 14.3098 25 14.9999C24.9999 15.69 24.4401 16.2496 23.75 16.2499H21.25C20.5599 16.2496 20.0001 15.69 20 14.9999C20.0001 14.3098 20.5599 13.7501 21.25 13.7499H23.75ZM20.7849 5.4271C21.3151 4.98569 22.1033 5.05722 22.5451 5.58702C22.9867 6.11729 22.9152 6.90659 22.3853 7.34849L20.5017 8.91832C19.9715 9.35983 19.1821 9.28834 18.7402 8.7584C18.2986 8.22839 18.3708 7.44024 18.9001 6.99815L20.7849 5.4271Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMute);
export default __webpack_public_path__ + "static/media/un-mute.d307c445de740fbbcc8ee53d4e6ba148.svg";
export { ForwardRef as ReactComponent };